import Axios from "axios";
import React, { useState, useEffect, Fragment } from "react";
import { MainBlock, MiniBlock } from "../../../components/common/Buttons";
import PreviewComment from "../../../components/common/GlobalModals/Orders/editModal/previewComment";
import { Divs } from "../../../components/common/StyledComponents";
import ModalCreateComment from "../../../components/Layout/Modals/ModalCreateComment";

export default function RenderComments({
  disabled,
  comments,
  id,
  opennedModalTables,
  updateOpennedModalTables,
}) {
  const [commentState, setCommentState] = useState([]);

  useEffect(() => {
    const fetchCommentStates = async () => {
      try {
        const { data } = await Axios.get("/pickups/requests/comment_states");
        setCommentState(
          data.map((e) => ({
            ...e,
            label: e.name,
            value: e.id,
          }))
        );
      } catch (err) {
        console.log("Error: ", err);
      }
    };
    fetchCommentStates();
  }, []);

  return (
    <Divs className="bg-silver">
      <MainBlock
        color={"#008aff"}
        action={opennedModalTables.comments}
        onChange={() => updateOpennedModalTables("comments")}
      >
        Komentarai
      </MainBlock>
      {opennedModalTables.comments && (
        <div className="mb-4 pb-2">
          <MiniBlock
            color={"#7ebff7"}
            action={opennedModalTables.comments_store}
            onChange={() => updateOpennedModalTables("comments_store")}
          >
            Parduotuvės komentarai
          </MiniBlock>
          <Fragment>
            {opennedModalTables.comments_store && (
              <div className="col-12">
                {!disabled && (
                  <ModalCreateComment
                    type="comment_tch_pickup"
                    record_type="requests"
                    record_id={id}
                    comment_states={commentState}
                  />
                )}
                <PreviewComment comments={comments} type="comment_tch_pickup" />
              </div>
            )}
          </Fragment>
        </div>
      )}
    </Divs>
  );
}
